import { useEffect } from "react";
import WebSocketManager from "./client.js";

export function useCashFlowUpdates({ clientCode, onOpened, onClosed }) {
    useEffect(() => {
        if (!clientCode) return;

        const topic = `/topic/clients/${clientCode}/cashflow`;

        const callback = (message) => {
            if (message === "OPENED" && onOpened) onOpened();
            if (message === "CLOSED" && onClosed) onClosed();
        };

        WebSocketManager.subscribe(topic, callback);

        return () => {
            WebSocketManager.unsubscribe(topic);
        };
    }, [clientCode, onOpened, onClosed]);
}
